import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { toast } from "react-toastify"
import api, { timeout } from "../../api"
import { setMessage } from "../message/messageSlice"

//DIVISIONS
export const getDivisions = createAsyncThunk(
  "govsettings/getDivisions",
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.get(`abide/v2/segments/functional/divisions`)
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      dispatch(setMessage(message))
      return rejectWithValue()
    }
  }
)
export const getdivisionDropdown = createAsyncThunk(
  "govsettings/getdivisionDropdown",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(`abide/v2/segments/functional/divisions`)
      return response?.data
    } catch (error) {
      return rejectWithValue()
    }
  }
)

export const addDivision = createAsyncThunk(
  "govsettings/addDivision",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post(
        "abide/v2/segments/functional/division/add",
        inputData
      )
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const editDivision = createAsyncThunk(
  "govsettings/editDivision",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post(
        "abide/v2/segments/division/edit",
        inputData
      )
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const deleteDivision = createAsyncThunk(
  "govsettings/deleteDivision",
  async ({ id }, thunkAPI) => {
    try {
      const response = await api.post(
        `abide/v2/segments/functional/delete/${id}`,
        {}
      )
      if (response) {
        toast.success("Division deleted successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)

//FUNCTIONS
export const getFunctions = createAsyncThunk(
  "govsettings/getFunctions",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(`abide/v2/segments/functions`)
      return response?.data
    } catch (error) {
      return rejectWithValue()
    }
  }
)

export const addFunction = createAsyncThunk(
  "govsettings/addFunction",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post(
        "abide/v2/segments/functions/add",
        inputData
      )
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const editFunction = createAsyncThunk(
  "govsettings/editfunction",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post(
        "abide/v2/segments/functions/edit",
        inputData
      )
      if (response) {
        toast.success("Function updated successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const deleteFunction = createAsyncThunk(
  "govsettings/deleteFunction",
  async ({ id }, thunkAPI) => {
    try {
      const response = await api.post(
        `abide/v2/segments/functions/delete/${id}`,
        {}
      )
      if (response) {
        toast.success("Function deleted successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)

//GROUPS
export const getGroups = createAsyncThunk(
  "govsettings/getGroups",
  async ({ divisionId }, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.get(`abide/v2/segments/groups/${divisionId}`)
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      dispatch(setMessage(message))
      return rejectWithValue()
    }
  }
)
export const getgroup = createAsyncThunk(
  "govsettings/getgroup",
  async ({ groupId }, { rejectWithValue }) => {
    try {
      const response = await api.get(`abide/v2/segments/group/${groupId}`)
      return response?.data
    } catch (error) {
      return rejectWithValue()
    }
  }
)
export const addGroup = createAsyncThunk(
  "govsettings/addGroup",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post(
        "abide/v2/segments/functional/group/add",
        inputData
      )

      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const editgroup = createAsyncThunk(
  "govsettings/editgroup",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post(
        "abide/v2/segments/groups/edit",
        inputData
      )
      if (response) {
        toast.success("Group updated successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)

//POLICIES
export const getPolicies = createAsyncThunk(
  "govsettings/getPolicies",
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.get(`abide/v2/segments/programmes/policies`)
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      dispatch(setMessage(message))
      return rejectWithValue()
    }
  }
)
export const getpolicy = createAsyncThunk(
  "govsettings/getpolicy",
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await api.get(`abide/v2/segments/policy/${id}`)
      return response?.data
    } catch (error) {
      return rejectWithValue()
    }
  }
)
export const addPolicy = createAsyncThunk(
  "govsettings/addPolicy",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post(
        "abide/v2/segments/programmes/policy/add",
        inputData
      )

      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)

//PROGRAMMES
export const getprogrammes = createAsyncThunk(
  "govsettings/getprogrammes",
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.get(`abide/v2/segments/programmes`)
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      dispatch(setMessage(message))
      return rejectWithValue()
    }
  }
)
export const getprogramme = createAsyncThunk(
  "govsettings/getprogramme",
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await api.get(`abide/v2/segments/programme/${id}`)
      return response?.data
    } catch (error) {
      return rejectWithValue()
    }
  }
)
export const addprogramme = createAsyncThunk(
  "govsettings/addprogramme",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post(
        "abide/v2/segments/programmes/programme/add",
        inputData
      )
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const editprogramme = createAsyncThunk(
  "govsettings/editprogramme",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post(
        "abide/v2/segments/programmes/edit",
        inputData
      )
      if (response) {
        toast.success("Programme updated successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const deleteProgramme = createAsyncThunk(
  "govsettings/deleteProgramme",
  async ({ id }, thunkAPI) => {
    try {
      const response = await api.post(
        `abide/v2/segments/programmes/delete/${id}`,
        {}
      )
      if (response) {
        toast.success("Programme deleted successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message = error?.response?.data || error.message || error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
//PROJECTS
export const addProject = createAsyncThunk(
  "govsettings/addProject",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post(
        "abide/v2/segments/project/add",
        inputData
      )
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const editproject = createAsyncThunk(
  "govsettings/editproject",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post(
        "abide/v2/segments/project/edit",
        inputData
      )
      if (response) {
        toast.success("Project updated successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)

//OBJECTIVES
export const getobjectives = createAsyncThunk(
  "govsettings/getobjectives",
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await api.get(
        `abide/v2/segments/objectives?project=${id}`
      )
      return response?.data
    } catch (error) {
      return rejectWithValue()
    }
  }
)
export const addobjective = createAsyncThunk(
  "govsettings/addobjective",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post(
        "abide/v2/segments/objective/add",
        inputData
      )
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const editobjective = createAsyncThunk(
  "govsettings/editobjective",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post(
        "abide/v2/segments/objective/edit",
        inputData
      )
      if (response) {
        toast.success("Objective updated successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const deleteobjective = createAsyncThunk(
  "govsettings/deleteobjective",
  async ({ id }, thunkAPI) => {
    try {
      const response = await api.post(
        `abide/v2/segments/objective/delete/${id}`,
        {}
      )
      if (response) {
        toast.success("Objective deleted successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message = error?.response?.data || error.message || error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)

//ACTIVITIES
export const getactivities = createAsyncThunk(
  "govsettings/getactivities",
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await api.get(
        `abide/v2/segments/activities?objective=${id}`
      )
      return response?.data
    } catch (error) {
      return rejectWithValue()
    }
  }
)
export const addactivity = createAsyncThunk(
  "govsettings/addactivity",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post(
        "abide/v2/segments/activity/add",
        inputData
      )
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const editactivity = createAsyncThunk(
  "govsettings/editactivity",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post(
        "abide/v2/segments/activity/edit",
        inputData
      )
      if (response) {
        toast.success("Activity updated successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const deleteactivity = createAsyncThunk(
  "govsettings/deleteactivity",
  async ({ id }, thunkAPI) => {
    try {
      const response = await api.post(
        `abide/v2/segments/activity/delete/${id}`,
        {}
      )
      if (response) {
        toast.success("Activity deleted successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message = error?.response?.data || error.message || error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)

//FUND SEGMENT
export const getFundEnvelop = createAsyncThunk(
  "govsettings/getFundEnvelop",
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.get(`abide/v2/segments/funding/fund`)
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      dispatch(setMessage(message))
      return rejectWithValue()
    }
  }
)

export const addFund = createAsyncThunk(
  "govsettings/addFund",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post(
        "abide/v2/segments/funding/fund/add",
        inputData
      )
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const editFund = createAsyncThunk(
  "govsettings/editFund",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post("abide/v2/segments/fund/edit", inputData)
      if (response) {
        toast.success("Fund updated successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const deleteFund = createAsyncThunk(
  "govsettings/deleteFund",
  async ({ id }, thunkAPI) => {
    try {
      const response = await api.post(
        `abide/v2/segments/funding/delete/${id}`,
        {}
      )
      if (response) {
        toast.success("Fund deleted successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)

export const addFunds = createAsyncThunk(
  "govsettings/addFunds",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post(
        "abide/v2/segments/funding/funds/add",
        inputData
      )
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const editFunds = createAsyncThunk(
  "govsettings/editFunds",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post(
        "abide/v2/segments/subfund/edit",
        inputData
      )
      if (response) {
        toast.success("Subfund updated successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)

export const addSource = createAsyncThunk(
  "govsettings/addSource",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post("abide/v2/segments/source/add", inputData)
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const editSource = createAsyncThunk(
  "govsettings/editSource",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post(
        "abide/v2/segments/funding/edit",
        inputData
      )
      if (response) {
        toast.success("Source updated successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const deleteSource = createAsyncThunk(
  "govsettings/deleteSource",
  async ({ id }, thunkAPI) => {
    try {
      const response = await api.post(
        `abide/v2/segments/source/delete/${id}`,
        {}
      )
      if (response) {
        toast.success("Source deleted successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
// REGIONS
export const getRegions = createAsyncThunk(
  "govsettings/getRegions",
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.get(`abide/v2/segments/locations/locations`)
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      dispatch(setMessage(message))
      return rejectWithValue()
    }
  }
)
export const addRegion = createAsyncThunk(
  "govsettings/addZone",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post(
        "abide/v2/segments/locations/region/add",
        inputData
      )

      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const editregion = createAsyncThunk(
  "govsettings/editZone",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post(
        "abide/v2/segments/locations/region/edit",
        inputData
      )
      if (response) {
        toast.success("Region updated successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
// ZONES
export const getzones = createAsyncThunk(
  "govsettings/getzones",
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.get(`abide/v2/segments/zones`)
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      dispatch(setMessage(message))
      return rejectWithValue()
    }
  }
)
export const addZone = createAsyncThunk(
  "govsettings/addZone",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post(
        "abide/v2/segments/locations/zone/add",
        inputData
      )

      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const editZone = createAsyncThunk(
  "govsettings/editZone",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post(
        "abide/v2/segments/locations/zone/edit",
        inputData
      )
      if (response) {
        toast.success("Zone updated successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)

// LOCATIONS

export const addlocation = createAsyncThunk(
  "govsettings/addlocation",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post(
        "abide/v2/segments/location/add",
        inputData
      )
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const editLocation = createAsyncThunk(
  "govsettings/editLocation",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post(
        "abide/v2/segments/locations/edit",
        inputData
      )
      if (response) {
        toast.success("Location updated successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const deleteLocation = createAsyncThunk(
  "govsettings/deleteLocation",
  async ({ id }, thunkAPI) => {
    try {
      const response = await api.post(
        `abide/v2/segments/locations/delete/${id}`,
        {}
      )
      if (response) {
        toast.success("Location deleted successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
// WARDS
export const addWard = createAsyncThunk(
  "govsettings/addWard",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post(
        "abide/v2/segments/locations/ward/add",
        inputData
      )
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const editWard = createAsyncThunk(
  "govsettings/editWard",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post(
        "abide/v2/segments/segments/locations/ward/edit",
        inputData
      )
      if (response) {
        toast.success("Ward updated successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const deleteWard = createAsyncThunk(
  "govsettings/deleteWard",
  async ({ id }, thunkAPI) => {
    try {
      const response = await api.post(
        `abide/v2/segments/segments/locations/ward/delete/${id}`,
        {}
      )
      if (response) {
        toast.success("Ward deleted successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
//TAG SEGMENT
export const gettags = createAsyncThunk(
  "govsettings/gettags",
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.get(`abide/v2/segments/tags`)
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      dispatch(setMessage(message))
      return rejectWithValue()
    }
  }
)
export const getTagsDropdown = createAsyncThunk(
  "govsettings/getTagsDropdown",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(`abide/v2/segments/tags`)
      return response?.data
    } catch (error) {
      return rejectWithValue()
    }
  }
)
export const addtag = createAsyncThunk(
  "govsettings/addtag",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post("abide/v2/segments/tag/add", inputData)
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const edittag = createAsyncThunk(
  "govsettings/edittag",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post("abide/v2/segments/tag/edit", inputData)
      if (response) {
        toast.success("Tag updated successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const deletetag = createAsyncThunk(
  "govsettings/deletetag",
  async ({ id }, thunkAPI) => {
    try {
      const response = await api.post(`abide/v2/segments/tag/delete/${id}`, {})
      if (response) {
        toast.success("Fund deleted successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)

//MONITORING CHECKLIST
export const getMonitoringChecklists = createAsyncThunk(
  "govsettings/getMonitoringChecklists",
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.get(`abide/v2/segments/checklists`)
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      dispatch(setMessage(message))
      return rejectWithValue()
    }
  }
)

export const getMonitoringChecklistsdropdown = createAsyncThunk(
  "govsettings/getMonitoringChecklistsdropdown",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(`abide/v2/segments/checklists`)
      return response?.data
    } catch (error) {
      return rejectWithValue()
    }
  }
)

export const addMonitoringChecklist = createAsyncThunk(
  "govsettings/addMonitoringChecklist",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post(
        "abide/v2/segments/checklist/domain/add",
        inputData
      )
      if (response) {
        toast.success("Chelist added successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const addChecklistCriteria = createAsyncThunk(
  "govsettings/addChecklistCriteria",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post(
        "abide/v2/segments/checklist/criteria/add",
        inputData
      )
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const editMonitoringChecklist = createAsyncThunk(
  "govsettings/editMonitoringChecklist",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post(
        "abide/v2/segments/checklist/edit",
        inputData
      )
      if (response) {
        toast.success("Checklist updated successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const deleteMonitoringChecklist = createAsyncThunk(
  "govsettings/deleteMonitoringChecklist",
  async ({ id }, thunkAPI) => {
    try {
      const response = await api.post(
        `abide/v2/segments/checklist/delete/${id}`,
        {}
      )
      if (response) {
        toast.success("Checklist deleted successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
//CONTRACTORS
export const getContractors = createAsyncThunk(
  "govsettings/getContractors",
  async (
    { status, rating, search, cursor, navigation, pagesize },
    { dispatch, rejectWithValue }
  ) => {
    try {
      const response = await api.get(
        `abide/v1/procurement/contractors?status=${status}&rating=${rating}&search=${search}&cursor=${cursor}&navigation=${navigation}&page-szie=${pagesize}`
      )
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      dispatch(setMessage(message))
      return rejectWithValue()
    }
  }
)
export const getContractorsDropdown = createAsyncThunk(
  "govsettings/getContractorsDropdown",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(`abide/v1/procurement/contractors/basic`)
      return response?.data
    } catch (error) {
      return rejectWithValue()
    }
  }
)
export const getContractorDetails = createAsyncThunk(
  "govsettings/getContractorDetails",
  async ({ id }, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.get(`abide/v1/procurement/contractor/${id}`)
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      dispatch(setMessage(newMessage))
      return rejectWithValue()
    }
  }
)
export const addContractor = createAsyncThunk(
  "govsettings/addContractor",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post(
        "abide/v1/procurement/contractor/add",
        inputData
      )
      if (response) {
        toast.success("Contractor added successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const editContractor = createAsyncThunk(
  "govsettings/editContractor",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post(
        "abide/v1/procurement/contractor/update",
        inputData
      )
      if (response) {
        toast.success("Contractor updated successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const deleteContractor = createAsyncThunk(
  "govsettings/deleteContractor",
  async ({ id }, thunkAPI) => {
    try {
      const response = await api.post(
        `abide/v1/procurement/contractor/delete/${id}`,
        {}
      )
      if (response) {
        toast.success("Contractor deleted successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)

const initialState = {
  details: null,
  divisions: null,
  loading: false,
  functions: null,
  policies: null,
  project: null,
  objectives: null,
  activities: null,
  policy: null,
  programmes: null,
  programmedetail: null,
  programmeloading: false,
  groups: null,
  group: null,
  grouploading: false,
  funds: null,
  subfunds: null,
  subfund: null,
  subfundloading: false,
  sources: null,
  zones: null,
  regions: null,
  locationloading: false,
  tags: null,
  checklists: null,
  contractors: null,
}

const govsettingsSlice = createSlice({
  name: "govsettings",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //DIVISIONS
    builder.addCase(getDivisions.pending, (state) => {
      state.loading = true
      state.divisions = null
    })
    builder.addCase(getDivisions.fulfilled, (state, { payload }) => {
      state.loading = false
      state.divisions = payload.data
    })
    builder.addCase(getDivisions.rejected, (state) => {
      state.loading = false
      state.divisions = null
    })
    builder.addCase(getdivisionDropdown.fulfilled, (state, { payload }) => {
      state.loading = false
      state.divisions = payload.data
    })
    builder.addCase(getFunctions.fulfilled, (state, { payload }) => {
      state.loading = false
      state.functions = payload.data
    })

    //Functional groups
    builder.addCase(getGroups.pending, (state) => {
      state.grouploading = true
      state.groups = null
    })
    builder.addCase(getGroups.fulfilled, (state, { payload }) => {
      state.grouploading = false
      state.groups = payload.data
    })
    builder.addCase(getGroups.rejected, (state) => {
      state.grouploading = false
      state.groups = null
    })
    builder.addCase(getgroup.pending, (state) => {
      state.grouploading = true
      state.group = null
    })
    builder.addCase(getgroup.fulfilled, (state, { payload }) => {
      state.grouploading = false
      state.group = payload.data
    })
    builder.addCase(getgroup.rejected, (state) => {
      state.grouploading = false
      state.group = null
    })
    //POLICIES
    builder.addCase(getPolicies.pending, (state) => {
      state.loading = true
      state.policies = null
    })
    builder.addCase(getPolicies.fulfilled, (state, { payload }) => {
      state.loading = false
      state.policies = payload.data
    })
    builder.addCase(getPolicies.rejected, (state) => {
      state.loading = false
      state.policies = null
    })

    //POLICY
    builder.addCase(getpolicy.pending, (state) => {
      state.policyloading = true
      state.policy = null
    })
    builder.addCase(getpolicy.fulfilled, (state, { payload }) => {
      state.policyloading = false
      state.policy = payload.data
    })
    builder.addCase(getpolicy.rejected, (state) => {
      state.policyloading = false
      state.policy = null
    })
    //OBJECTIVES
    builder.addCase(getobjectives.fulfilled, (state, { payload }) => {
      state.objectives = payload.data
    })
    //ACTIVITIES

    builder.addCase(getactivities.fulfilled, (state, { payload }) => {
      state.activities = payload.data
    })

    builder.addCase(getprogrammes.pending, (state) => {
      state.programmeloading = true
      state.programmes = null
    })
    builder.addCase(getprogrammes.fulfilled, (state, { payload }) => {
      state.programmeloading = false
      state.programmes = payload.data
    })
    builder.addCase(getprogrammes.rejected, (state) => {
      state.programmeloading = false
      state.programmes = null
    })
    builder.addCase(getprogramme.pending, (state) => {
      state.programmeloading = true
      state.programmedetail = null
    })
    builder.addCase(getprogramme.fulfilled, (state, { payload }) => {
      state.programmeloading = false
      state.programmedetail = payload.data
    })
    builder.addCase(getprogramme.rejected, (state) => {
      state.programmeloading = false
      state.programmedetail = null
    })
    //FUNDS
    builder.addCase(getFundEnvelop.pending, (state) => {
      state.loading = true
      state.funds = null
    })
    builder.addCase(getFundEnvelop.fulfilled, (state, { payload }) => {
      state.loading = false
      state.funds = payload.data
    })
    builder.addCase(getFundEnvelop.rejected, (state) => {
      state.loading = false
      state.funds = null
    })

    // GET REGIONS
    builder.addCase(getRegions.pending, (state) => {
      state.loading = true
      state.regions = null
    })
    builder.addCase(getRegions.fulfilled, (state, { payload }) => {
      state.loading = false
      state.regions = payload.data
    })
    builder.addCase(getRegions.rejected, (state) => {
      state.loading = false
      state.regions = null
    })
    //GET ZONES
    builder.addCase(getzones.pending, (state) => {
      state.loading = true
      state.zones = null
    })
    builder.addCase(getzones.fulfilled, (state, { payload }) => {
      state.loading = false
      state.zones = payload.data
    })
    builder.addCase(getzones.rejected, (state) => {
      state.loading = false
      state.zones = null
    })
    //TAGS
    builder.addCase(gettags.pending, (state) => {
      state.loading = true
      state.tags = null
    })
    builder.addCase(gettags.fulfilled, (state, { payload }) => {
      state.loading = false
      state.tags = payload.data
    })
    builder.addCase(gettags.rejected, (state) => {
      state.loading = false
      state.tags = null
    })
    //TAGS DROPDOWN
    builder.addCase(getTagsDropdown.fulfilled, (state, { payload }) => {
      state.tags = payload.data
    })
    //MONITORING CHECKLISTS
    builder.addCase(getMonitoringChecklists.pending, (state) => {
      state.loading = true
      state.checklists = null
    })
    builder.addCase(getMonitoringChecklists.fulfilled, (state, { payload }) => {
      state.loading = false
      state.checklists = payload.data
    })
    builder.addCase(getMonitoringChecklists.rejected, (state) => {
      state.loading = false
      state.checklists = null
    })
    //MONITORING CHECKLIST DROPDOWN
    builder.addCase(
      getMonitoringChecklistsdropdown.fulfilled,
      (state, { payload }) => {
        state.checklists = payload.data
      }
    )
    //CONTRACTORS
    builder.addCase(getContractors.pending, (state) => {
      state.loading = true
      state.contractors = null
    })
    builder.addCase(getContractors.fulfilled, (state, { payload }) => {
      state.loading = false
      state.contractors = payload.data
    })
    builder.addCase(getContractors.rejected, (state) => {
      state.loading = false
      state.contractors = null
    })
    builder.addCase(getContractorsDropdown.fulfilled, (state, { payload }) => {
      state.loading = false
      state.contractors = payload.data
    })
    builder.addCase(getContractorDetails.fulfilled, (state, { payload }) => {
      state.details = payload.data
    })
  },
})

export default govsettingsSlice.reducer
